<div class="titulo-painel">
    <h3>{{titulo}}</h3>
</div>